export const CURRENT_SESSION_SET_TOKEN = "CURRENT_SESSION_SET_TOKEN"; 
export const CURRENT_SESSION_SET_DATETIME = "CURRENT_SESSION_SET_DATETIME"; 
export const CURRENT_SESSION_SET_VALIDUNTIL = "CURRENT_SESSION_SET_VALIDUNTIL"; 

export const CURRENT_SESSION_SET_LOGGEDIN = "CURRENT_SESSION_SET_LOGGEDIN"; 
export const CURRENT_SESSION_SET_INFOMESSAGE = "CURRENT_SESSION_SET_INFOMESSAGE"; 
export const CURRENT_SESSION_SET_ERRORMESSAGE = " CURRENT_SESSION_SET_ERRORMESSAGE"; 
